
import { Component, Watch } from "vue-property-decorator";
import moment from "moment";
import { LectureTableConfig } from "@/components/lecture/main/model/LectureTableConfig";
import InquiredLectureListModel from "@/service/model/lecture/InquiredLectureListModel";
import { lectureService } from "@/service/api/LectureService";
import { RouterMenuName } from "@/enum/RouterMenuName";
import Base from "@/Base";

@Component
export default class LectureList extends Base {
  private lectureTableConfig = LectureTableConfig;
  private lectureListData: PageData<
    InquiredLectureData
  > = new InquiredLectureListModel();

  public created(): void {
    this.queryWatch();
  }

  @Watch("$route.query", { immediate: true })
  private queryWatch(): void {
    this.getLectureListData();
  }

  private getLectureListData(): void {
    if (this.loading$) this.loading$.open();

    lectureService
      .retrieveLectureList(
        this.$route.query.page ? parseInt(this.$route.query.page as string) : 1,
        10,
        this.$route.query.searchType as string,
        this.$route.query.searchValue as string
      )
      .subscribe((inquiredLectureData: PageData<InquiredLectureData>) => {
        this.lectureListData = inquiredLectureData;
        this.loading$.close();
      });
  }

  private onChangePage(page: number): void {
    this.$router.push({
      query: {
        ...this.$route.query,
        page: page.toString()
      }
    });
  }

  private inventedRowKey(record: InquiredLectureData, index: number): string {
    return record.lecture.id + "." + index;
  }

  private onClickTableRow(record: InquiredLectureData): void {
    this.$router.push({
      name: RouterMenuName.LectureDetail,
      params: {
        id: record.lecture.id.toString()
      }
    });
  }

  private setDateFormat(date: string): string {
    return moment(date).format("YYYY-MM-DD");
  }
}
